export const data = {
  titles: {
    propertyList: 'Property List',
    search: 'Search',
    filter: 'Filter'
  },
  tableHeading: {
    admin: [
      'Property Type',
      'Property Name',
      'Landlord Name',
      'Status',
      'Edit'
    ],
    landlord: [
      'Property Type',
      'Property Name',
      'Tenant Name',
      'Total Amount',
      'Due in',
      'Status',
      'Edit'
    ],
    manager: [
      'Property Type',
      'Property Name',
      'Tenant Name',
      'Total Amount',
      'Due in',
      'Status',
      'Action'
    ],
    tenant: [
      'Property Type',
      'Property Name',
      'Landlord Name',
      'Status',
      'Details'
    ]
  },
  cta: {
    addProperty: 'Add New Property'
  }
};

export const statusClass = (status, classes) => {
    if (status === 'active') {
        return classes.active
    }
    if (status === 'draft') {
        return classes.draft
    }
    if (status === 'inactive') {
        return classes.inactive
    }
    if (status === 'disabled') {
        return classes.disabled
    }
}
export const propertiesUserType = {
    admin: 'Admin',
    landlord: 'Landlord',
    tenant: 'Tenant'
}